import { render, staticRenderFns } from "./BlocksCrud.vue?vue&type=template&id=fe3f5a62&"
import script from "./BlocksCrud.vue?vue&type=script&lang=js&"
export * from "./BlocksCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports